import { Sparkles, Loader2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

/**
 * Barre de recherche IA en langage naturel pour le Vivier.
 *
 * Props:
 *  - query, setQuery       : contrôlé
 *  - onSearch()            : déclenche l'analyse
 *  - onClear()             : réinitialise la requête + le résumé
 *  - searching             : bool → affiche loader + désactive le bouton
 *  - summary               : résumé lisible retourné par l'IA (facultatif)
 */
export default function VivierAiSearchBar({ query, setQuery, onSearch, onClear, searching = false, summary = "" }) {
  return (
    <div
      className="bg-gradient-to-r from-[#F0E9F3] to-[#E6F0F7] border border-[#662483]/30 p-3"
      data-testid="ai-search-block"
    >
      <div className="flex items-center gap-2 mb-2">
        <Sparkles className="w-4 h-4 text-[#662483]" />
        <p className="text-xs font-bold text-[#662483] uppercase tracking-wider">Recherche IA — langage naturel</p>
        {searching && <Loader2 className="w-3.5 h-3.5 animate-spin text-[#662483]" />}
      </div>
      <div className="flex gap-2">
        <Input
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          onKeyDown={(e) => { if (e.key === "Enter") onSearch(); }}
          placeholder='Ex: "Cariste CACES 3 à moins de 20km de Lyon dispo demain"'
          className="rounded-none text-sm h-9 bg-white"
          data-testid="ai-search-input"
        />
        <Button
          onClick={onSearch}
          disabled={searching || !query.trim()}
          className="bg-gradient-to-r from-[#662483] to-[#0069B4] text-white rounded-none text-xs h-9 px-4 font-semibold shrink-0"
          data-testid="ai-search-btn"
        >
          <Sparkles className="w-3.5 h-3.5 mr-1" /> {searching ? "Analyse..." : "Chercher"}
        </Button>
      </div>
      {summary && (
        <div className="mt-2 flex items-center justify-between gap-2" data-testid="ai-search-summary">
          <p className="text-[11px] text-[#3F3F3F]">
            <span className="font-semibold text-[#662483]">Interprétation :</span> {summary}
          </p>
          <button type="button" onClick={onClear} className="text-[10px] text-red-500 hover:underline">Effacer</button>
        </div>
      )}
    </div>
  );
}
